import React from 'react'
import pharma4linkLogo from '../../assets/logos/pharma4link.svg'

interface Pharma4LinkMarkProps {
  /** Logo width in px. Height follows the artwork — viewBox 421.6 x 392.4, so ~0.93x. */
  width?: number
  /** Outer layout only — margins, alignment. Not size. */
  className?: string
}

/**
 * Pharma4Link on its own, without the "empowered by Broxel EQS" endorsement that
 * <BrandLockup /> carries.
 *
 * This exists for the logged-in customer dashboard. The endorsement is already made
 * on /login and in the public Footer, and the side-by-side lockup cannot fit a 256 px
 * rail regardless: the artwork is near square, so at width W the lockup wants ~2.2W
 * across and ~0.93W of height, and nothing in it clips.
 *
 * Unlike BrandLockup this needs no dir="ltr" — it is a single image rather than a mark
 * beside a word, so RTL has nothing to re-order.
 */
const Pharma4LinkMark: React.FC<Pharma4LinkMarkProps> = ({ width = 112, className }) => (
  <img src={pharma4linkLogo} alt="Pharma4Link" style={{ width }} className={className} />
)

export default Pharma4LinkMark
